import {z} from "zod/v4-mini"

export type Distribution = "BECKMANN" | "GGX" | "MULTI_GGX"
export const distributionSchema = z.enum(["BECKMANN", "GGX", "MULTI_GGX"])
